import React from 'react';
import { Wrapper as WrapperDesk } from '@catalogo/ui-americanas-desktop-freight/src/styles';
import { Wrapper as WrapperMobile } from '@catalogo/ui-americanas-mobile-freight/src/styles';

export const Wrapper = ({ device, children }) => {
  if (device?.toLowerCase() === 'mobile') {
    return <WrapperMobile>{children}</WrapperMobile>;
  }
  return <WrapperDesk>{children}</WrapperDesk>;
};
